/* eslint-disable no-useless-escape */
import React, { createRef } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FallingLines } from 'react-loader-spinner';
import {
  REGISTER,
  INITIATE_REGISTER,
  HAVE_ACCOUNT,
  ENTER,
  ALREADY_REGISTERED,
  REGISTER_SUCCESS,
  REGISTER_SUCCESS_TEXT,
  CONTINUE,
} from '../../../Utils/Constants/GlobalConstants';
import {
  changeUserAuthStatus,
  changeUserFirstLetter,
} from '../../../DataStore/actions/searchFormActions';
import './css/RegisterForm.css';
import { ReactComponent as Radio } from '../../../images/radio-r.svg';
import { ReactComponent as RadioSelected } from '../../../images/radio-selected-r.svg';
import { ReactComponent as Success } from '../../../images/success-r.svg';

const mapStateToProps = (state) => ({ ...state });

class RegisterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailValue: '',
      passwordValue: '',
      emailWasFocused: false,
      isEmailValid: false,
      isPasswordValid: false,
      name: '',
      errorMessage: '',
      isSubmitSpinnerVisible: false,
      isRadioSelected: false,
      isRegistered: false,
    };
  }

  handlePasswordChange = (e) => {
    const password = e.target.value;
    this.setState({ passwordValue: password }, () => {
      this.passwordValidator();
    });
  };

  handleEmailChange = (e) => {
    const { emailWasFocused } = this.state;
    const emailValue = e.target.value;
    this.setState({ emailValue });

    if (emailWasFocused) {
      if (this.emailValidation()) {
        this.setState({ isEmailValid: true });
      } else {
        this.setState({ isEmailValid: false });
      }
    }
  };

  passwordValidator = () => {
    const { passwordValue } = this.state;
    if (passwordValue.length >= 1) {
      this.setState({ isPasswordValid: true });
    } else {
      this.setState({ isPasswordValid: false });
    }
  };

  emailValidation = () => {
    const { emailValue } = this.state;
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!emailValue || regex.test(emailValue) === false) {
      return false;
    }
    return true;
  };

  handleEmailInputBlur = () => {
    const { emailValue } = this.state;
    if (emailValue.length > 0) {
      if (this.emailValidation()) {
        this.setState({ isEmailValid: true });
      } else {
        this.setState({ isEmailValid: false });
      }
      this.setState({ emailWasFocused: true });
    }
  };

  register = (btnRef) => {
    btnRef.current.setAttribute('disabled', 'disabled');
    this.setState({ isSubmitSpinnerVisible: true });

    const { emailValue, passwordValue, name } = this.state;
    const {
      changeUserAuthStatus: changeUserAuthStatusAction,
      changeUserFirstLetter: changeUserFirstLetterAction,
    } = this.props;

    axios
      .post('/api/auth/signup', {
        username: name,
        email: emailValue,
        password: passwordValue,
        role: ['user'],
      })
      .then((res) => {
        const { email } = res.data;
        window.localStorage.setItem('accessToken', res.data.accessToken);
        window.localStorage.setItem('email', email);
        window.localStorage.setItem('isUserLoggedIn', true);

        if (email) {
          changeUserFirstLetterAction(email.charAt(0).toUpperCase());
        }

        changeUserAuthStatusAction(true);
        this.setState({ isRegistered: true });
      })
      .catch((error) => {
        if (error.code === 'ERR_BAD_REQUEST') {
          if (
            error.response.data.message === 'Error: Email is already in use!'
          ) {
            this.setState({
              errorMessage: ALREADY_REGISTERED,
            });
          }
        }
      })
      .finally(() => {
        this.setState({ isSubmitSpinnerVisible: false });
      });
  };

  handleContinueClick = () => {
    const { closeModal, location } = this.props;

    closeModal();

    if (location.pathname === '/profile') {
      window.location.reload();
    }
  };

  renderSuccess = () => {
    const { emailValue } = this.state;

    return (
      <div className="login_form_w">
        <Success className="rf_success_ico" />
        <div className="bm_text_24 login_title">{REGISTER_SUCCESS}</div>
        <div className="rf_success_text gr_text_16">
          {`${REGISTER_SUCCESS_TEXT} ${emailValue}`}
        </div>
        <div className="login_button_w">
          <button
            type="button"
            className="login_button blue_button login_btn_active"
            onClick={this.handleContinueClick}
          >
            {CONTINUE}
          </button>
        </div>
      </div>
    );
  };

  render() {
    const {
      emailValue,
      passwordValue,
      isEmailValid,
      emailWasFocused,
      isPasswordValid,
      errorMessage,
      isSubmitSpinnerVisible,
      isRadioSelected,
      isRegistered,
    } = this.state;

    const { showLoginForm } = this.props;

    if (isRegistered) {
      return this.renderSuccess();
    }

    const btnRef = createRef();

    return (
      <div className="login_form_w">
        <div className="bm_text_24 login_title">{REGISTER}</div>
        <input
          value={emailValue}
          className={`login_form_input ${
            !isEmailValid && emailWasFocused ? 'logon_ivalid_input' : ''
          }`}
          onChange={this.handleEmailChange}
          placeholder="Email"
          onBlur={this.handleEmailInputBlur}
        />
        <input
          value={passwordValue}
          className={`login_form_input ${isEmailValid ? '' : ''}`}
          onChange={this.handlePasswordChange}
          placeholder="Пароль"
          type="password"
        />

        <div className="lonin_approve_w">
          <button
            className="login_approve_btn"
            type="button"
            onClick={() => this.setState({ isRadioSelected: !isRadioSelected })}
          >
            {isRadioSelected ? <RadioSelected /> : <Radio />}
          </button>
          <div className="lonin_approve_text gr_text_14">
            Нажимая на кнопку, я даю «Согласие на обработку персональных
            данных», ознакомлен с{' '}
            <Link target="_blank" to="https://tourhunter.by/file/politika.pdf">
              механизмом их обработки.
            </Link>
          </div>
        </div>

        <div className="login_button_w">
          <button
            ref={btnRef}
            type="submit"
            className={`login_button ${
              isPasswordValid && isEmailValid && isRadioSelected
                ? 'blue_button login_btn_active'
                : 'login_btn_dis'
            }`}
            disabled={!isPasswordValid && !isEmailValid && isRadioSelected}
            onClick={() => this.register(btnRef)}
          >
            <div className="login_button_content">
              {INITIATE_REGISTER}
              <div className="login-falling-loading">
                <FallingLines
                  color="#ffffff"
                  width="30"
                  visible={isSubmitSpinnerVisible}
                />
              </div>
            </div>
          </button>
          <div className="login_form_message rr_text_14">{errorMessage}</div>
        </div>

        <div className="login_show_reg">
          <span className="gr_text_16">
            {HAVE_ACCOUNT}
            &nbsp;
          </span>
          <button
            type="submit"
            className="blue_link login_register"
            onClick={showLoginForm}
          >
            {ENTER}
          </button>
        </div>
      </div>
    );
  }
}

RegisterForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  changeUserAuthStatus: PropTypes.func.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  showLoginForm: PropTypes.func.isRequired,
  changeUserFirstLetter: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  changeUserAuthStatus,
  changeUserFirstLetter,
})(RegisterForm);
